/* import __COLOCATED_TEMPLATE__ from './capability-filter-item.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();